import React, { Component } from 'react';
import { string } from 'prop-types';

import * as c from '../../lib/AppConstants';

class PracticeMap extends Component {
  static propTypes = {
    address: string,
  };

  render = () => {
    if (this.props.address) {
      return (
        <iframe
          title="practiceMap"
          id="map_canvas"
          style={{ width: '100%', height: '100%' }}
          src={`https://www.google
.com/maps/embed/v1/place?key=${c.GOOGLE_MAPS_API_KEY}&q=${this.props.address}`}>
        </iframe>
      );
    }
    return null;
  }
}

export default PracticeMap;



// WEBPACK FOOTER //
// ./src/components/PracticeMap/PracticeMap.js